import React from "react";
import { useSessionStore } from "../../storez/SessionStore";
import DeviceMenu from "./DeviceMenu";

const DeviceTab: React.FC = () => {
  if (!useSessionStore.getState().device) {
    return <></>;
  }

  return <DeviceMenu />;
};

export default DeviceTab;
